import {
  createSpot,
  editSpot,
  removeSeat,
  publish,
  unpublish,
  pauseSeat,
  resumeSeat,
} from './seats.service';

export default {
  namespaced: true,
  state: {
    seats: [],
  },
  mutations: {
    updateSeat(state, { id, seat }) {
      const index = state.seats.findIndex((e) => e.id === id);
      if (index !== -1) {
        state.seats.splice(index, 1, seat);
      }
    },
    removeSeat(state, id) {
      const index = state.seats.findIndex((e) => e.id === id);
      if (index !== -1) {
        state.seats.splice(index, 1);
      }
    },
    setSeats(state, seats) {
      state.seats = seats;
    },
    addSeat(state, seat) {
      state.seats.push(seat);
    },
  },
  actions: {
    async createSpot({ dispatch, commit }, params) {
      try {
        const seat = await createSpot(params);
        commit('addSeat', seat);
        dispatch(
          'notifications/addToastSuccess',
          { text: 'Your spot has been created.' },
          { root: true },
        );
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not create spot', error }, { root: true });
      }
    },

    async editSpot({ dispatch, commit }, params) {
      try {
        const seat = await editSpot(params);
        const seatId = params.id;
        commit('updateSeat', { id: seatId, seat });
        dispatch(
          'notifications/addToastSuccess',
          { text: 'Your edits have been saved.' },
          { root: true },
        );
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not edit spot', error }, { root: true });
      }
    },
    async removeSeat({ dispatch, commit }, { seatId, reason }) {
      try {
        await removeSeat(seatId, reason);
        commit('removeSeat', seatId);
        dispatch('notifications/addToastNotification', { text: 'Success! Seat has been removed.' }, { root: true });
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not remove seat', error }, { root: true });
      }
    },
    async publish({ dispatch, commit }, { seatId }) {
      try {
        const seat = await publish(seatId);
        commit('updateSeat', { id: seatId, seat });
        dispatch('notifications/addToastNotification', { text: 'Success! Seat has been published.' }, { root: true });
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not publish seat', error }, { root: true });
      }
    },
    async unpublish({ dispatch, commit }, { seatId }) {
      try {
        const seat = await unpublish(seatId);
        commit('updateSeat', { id: seatId, seat });
        dispatch('notifications/addToastNotification', { text: 'Success! Seat has been unpublished.' }, { root: true });
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not publish seat', error }, { root: true });
      }
    },
    async pauseSeat({ dispatch, commit }, { seatId }) {
      try {
        const seat = await pauseSeat(seatId);
        commit('updateSeat', { id: seatId, seat });
        dispatch('notifications/addToastNotification', { text: 'Success! Seat has been paused.' }, { root: true });
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not pause seat', error }, { root: true });
      }
    },
    async resumeSeat({ dispatch, commit }, { seatId }) {
      try {
        const seat = await resumeSeat(seatId);
        commit('updateSeat', { id: seatId, seat });
        dispatch('notifications/addToastNotification', { text: 'Success! Seat has been resumed.' }, { root: true });
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not resume seat', error }, { root: true });
      }
    },
    setSeats({ commit }, seats) {
      commit('setSeats', seats);
    },
  },
};
